import { Checkbox } from '../../../../../common/html/checkbox'
import { Element } from '../../../../../common/html/element'

const styleDisable = {
  opacity: 0.6,
  borderBottom: '1px solid #D5D5D5',
}
export const MAX_SIZE_COMPANY = 500

const ItemCheckBox = ({
  item,
  setListCheck,
  listCheck,
  showError,
  numberCompany,
}) => {
  const isMaxSize = item?.numberOfCompany + numberCompany > MAX_SIZE_COMPANY
  return (
    <Element
      className={['dFlex alignItemsCenter gap1'].join(' ')}
      style={
        !isMaxSize
          ? { borderBottom: '1px solid #D5D5D5', cursor: 'pointer' }
          : styleDisable
      }
    >
      <Checkbox
        title={item?.portfolioName}
        checked={listCheck.includes(item.portfolioId)}
        onChange={() => {
          if (isMaxSize) {
            return showError()
          }
          setListCheck((prevList) => {
            if ([...prevList].includes(item.portfolioId)) {
              return prevList.filter((key) => key !== item.portfolioId)
            }
            return [...prevList, item.portfolioId]
          })
        }}
        isCheckOnClickText
        styleIcon={{ fontSize: 15, paddingRight: 8 }}
        style={{
          padding: '6px 0',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: 390,
        }}
      />
    </Element>
  )
}

export default ItemCheckBox
